import { FunctionComponent } from 'react';

import { Container, Content01 } from '@/atoms';
import { Hero } from '@/molecules';
import { SliderHero } from '@/organisms';

import { ButtonVariant } from '@/atoms/button/types';
import { getUrlFromMedia } from '@/utils/utils';
import { ProductBlockShopify } from '@/templates';
import { StylePagination } from '@/organisms/slider-hero/types';
import { DrupalItemType, ItemListFilter } from '@/organisms/item-list-filter/ItemListFilter';
import { getParams } from '@/utils/drupal/get-params';

/**
 * ArticleCategory
 */
export const ArticleCategory: FunctionComponent<any> = ({ content }) => {
    const heroPosts = content.views.highlightedContent;
    const queryParams = getParams(DrupalItemType.ARTICLE, "card").addFilter("field_category", content.node.drupal_internal__tid);

    return (
        <div className="pt-header">
            <Container wrapper wrapperSize="max-w-[790px]">
                <Content01
                    pretitle={content.node.field_hide_in_listing ? "" : "ESCUELA DEL JAMÓN"}
                    title={content.node.name}
                    typeTitle="h1"
                    position="center"
                />
            </Container>

            {
                heroPosts.length > 0 ?
                    <Container wrapper>
                        <SliderHero pagination={StylePagination.ARTICLES_PAGINATION} className={`${heroPosts.length > 1 ? "md:mb-[30px]" : ""}`}>
                            {heroPosts.map((post: any, index: number) => (
                                <SliderHero.Slide key={index}>
                                    <Hero
                                        backgroundImage={getUrlFromMedia(post.field_image)}
                                        overlay={0.5}
                                        theme="dark"
                                        className="!p-10"
                                    >
                                        <Hero.Title>{post.title}</Hero.Title>
                                        <Hero.Button
                                            href={post.path.alias}
                                            variant={ButtonVariant.DISPLAY}
                                        >
                                            Ver post
                                        </Hero.Button>
                                    </Hero>
                                </SliderHero.Slide>
                            ))}
                        </SliderHero>
                    </Container>
                    : null
            }

            <ItemListFilter content={content.views.content} facetCount={content.facetCount} type={DrupalItemType.ARTICLE} queryParams={queryParams} />
            <Container wrapper>
                <ProductBlockShopify
                    shopifyCategory="destacados"
                    shopifyProducts={content.views.products}
                    title="Te puede interesar"
                />
            </Container>
        </div >

    )
};

ArticleCategory.displayName = 'PostCategory';
